module.exports = __webpack_public_path__ + "static/media/thirdpicture.ecff3238.png";